module.exports = window.c3;